<template>
  <div class="test-container">
    <!-- 操作 -->
    <div style="overflow:hidden;padding-bottom:19px;">
      <div>
        <span class="title">字典项</span>
        <div style="display:inline-block;float:right">
          <el-button
            type="primary"
            @click="add"
          >新增字典项</el-button>
        </div>

      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :key="tableKey"
      ref="multipleTable"
      v-loading="listLoading"
      stripe
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
      @cell-mouse-enter="operateShow"
      @cell-mouse-leave="operateClose"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        fixed
        label="编号"
        min-width="100px"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="文本"
        min-width="100px"
      >
        <template slot-scope="scope">{{ emptyDeal(scope.row.name) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="值"
        min-width="100px"
      >
        <template slot-scope="scope">{{ emptyDeal(scope.row.dicKey) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="排序号"
        width="100"
      >
        <template slot-scope="scope">
          <div class="updown">
            <i
              v-if="scope.row.sortNum!=1"
              class="el-icon-arrow-up"
              style="float:left;margin-top:-4px;margin-right:-16px"
              @click="editUp(scope.row)"
            />
            <i
              v-if="scope.row.sortNum!=downCode"
              class="el-icon-arrow-down"
              style="float:left;margin-top:8px;"
              @click="editDown(scope.row)"
            />
          </div>

        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="状态"
        min-width="100px"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.openStatus"
            :active-value="1"
            :inactive-value="0"
            @change="changeStatus(scope.row.id,scope.row.openStatus)"
          />
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        width="150px"
      >
        <template
          slot-scope="scope"
          class="icon"
        >
          <div class="icon">
            <i
              class="el-icon-change"
              @click="editRole(scope.row)"
            />
            <i
              class="el-icon-dele"
              style="margin-left:16px"
              @click="delet(scope.row.id)"
            />
          </div>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="mt10">
      <el-pagination
        :current-page="pageInfo.currentPage"
        :page-sizes="pageInfo.pageSizeList"
        :page-size="pageInfo.limit"
        layout="total, prev, pager, next, jumper"
        :total="pageInfo.allCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <template>
      <div v-if="isShowEdit">
        <EditDialog
          :edit-data="currentData"
          :isedit="isedit"
          :parent-id="ids"
          @handleclose="closeDialog"
          @refresh="getRoleList"
        />
      </div>
    </template>
  </div>
</template>
<script>
import { paramList, deleteDic, systemDetail, getSystem, dictList, addDic } from '@/api/system'
import EditDialog from './editDialog'
import { statusTrans, emptyTrans, sortDataList } from '@/api/dataTrans.js'
export default {
  components: { EditDialog },
  data () {
    return {
      dictId: null,
      list: [],
      listLoading: false,
      isShowEdit: false,
      isShowAdd: false,
      isedit: false,
      currentData: {},
      tableKey: 0,
      pageInfo: {
        limit: 10,
        allCount: 0,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      businessList: [],
      flag: false,
      type: 0,
      title: '添加角色',
      parmas: null,
      id: null,
      appIds: null,
      roleId: null,
      nameList: [],
      statusList: [{ code: 1, name: '开启' }, { code: 0, name: '关闭' }],
      ids: '',
      downCode: ''
    }
  },
  methods: {
    openStatusTrans (_val) {
      return statusTrans(_val, this.statusList)
    },
    getRoleList (_id) {
      this.dictId = _id || this.dictId
      // console.log(JSON.stringify(this.dictId))
      this.ids = this.dictId
      dictList({
        page: this.pageInfo.currentPage,
        size: this.pageInfo.limit,
        parentId: this.dictId
      }).then(res => {
        if (res && res.code == 0) {
          this.listLoading = false
          this.list = sortDataList(res.data.items, this.pageInfo.currentPage)
          this.pageInfo.allCount = res.data.total
          this.downCode = this.list.length
        }
      })
    },
    handleSizeChange (val) {
      this.pageInfo.limit = val
      this.pageInfo.currentPage = 1
      this.getRoleList()
    },
    handleCurrentChange (val) {
      this.pageInfo.currentPage = val
      this.getRoleList()
    },
    add () {
      this.currentData = {}
      this.isShowEdit = true
      this.isedit = false
    },
    editRole (data) {
      this.currentData = data
      this.isShowEdit = true
      this.isedit = true
    },
    getEditInfo (_id, isUp) {
      // return this.list[_id]
      let _curResult = null
      let _nexResult = null
      for (var i = 0; i < this.list.length; i++) {
        if (this.list[i].sort == _id) {
          if (isUp) {
            _nexResult = this.list[i - 1]
          } else {
            _nexResult = this.list[i + 1]
          }
          _curResult = this.list[i]
        }
      }
      return [_curResult, _nexResult]
    },
    sortItem (_obj, isUp) {
      const _handleObj = this.getEditInfo(_obj.sort, isUp)
      window.console.log(JSON.stringify(_handleObj))
      if (_handleObj[0] && _handleObj[1]) {
        const temp = _handleObj[0].sort
        _handleObj[0].sort = _handleObj[1].sort
        _handleObj[1].sort = temp
        addDic(_handleObj[0]).then(res => {
          if (res && res.code == 0) {

          }
        })
        addDic(_handleObj[1]).then(res => {
          if (res && res.code == 0) {
            this.getRoleList()
          }
        })
      }
    },
    editUp (_obj) {
      this.sortItem(_obj, true)
    },
    editDown (_obj) {
      this.sortItem(_obj, false)
    },
    closeDialog () {
      this.isShowEdit = false
      this.isShowAdd = false
      this.isedit = false
    },
    delet (data) {
      console.log(data)
      this.$confirm('您确认删除吗？', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        deleteDic({
          ids: data
        }).then(res => {
          this.$message.success('删除成功')
          this.getRoleList(this.dictId)
        })
      }).catch(() => { })
    },
    emptyDeal (_val) {
      return emptyTrans(_val)
    },
    // 业务类型
    businessStatus (_val) {
      return statusTrans(_val, this.businessList)
    },
    // 显示操作按钮
    operateShow (row, column, cell, event) {
      event.path[1].cells[5].children[0].children[0].style.display = 'block'
    },
    operateClose () {
      event.path[1].cells[5].children[0].children[0].style.display = 'none'
    },
    changeStatus (id, able) {
      addDic({
        id: id,
        openStatus: able
      }).then(res => {
        if (res && res.code == 0) {
          this.$message.success('操作成功')
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.operate {
  float: right;
  height: 24px;
}
[class^="el-icon-"] {
  // margin-left: 16px;
  font-size: 20px;
}
.title {
  text-align: left;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}
.el-button--primary {
  float: right;
}
.el-table {
  // margin-top: 16px;
}
body .app-wrapper-new-style .test-container {
  padding: 0px;
}
[class^="el-icon-"] {
  font-size: 16px;
  // margin-left: 24px;
}
[class^="el-icon-"]:hover {
  color: #ffa940;
}
.mt10 {
  margin-top: 24px !important;
  float: right;
}
.icon {
  display: none;
}
.set {
  margin-right: 24px;
  font-size: 14px;
  color: #ffa940;
  line-height: 30px;
}
.el-button {
  font-size: 14px;
}
.info {
  color: #ffa940;
}
</style>
